var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "min-w-0" },
    [
      _c("div", { staticClass: "text-subtitle-1 mb-4" }, [
        _vm._v("\n    Пол и возраст пациентов\n  "),
      ]),
      _vm._v(" "),
      _c(_setup.DiagramGender, { staticClass: "mb-4" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex flex-column gr-2",
          attrs: { "data-qa": "diagram_line_list" },
        },
        _vm._l(
          _setup.context.doctor_practice.practice_by_ages,
          function (agePractice, i) {
            return _c(_setup.DiagramLine, {
              key: i,
              attrs: {
                label: agePractice.age,
                percent: agePractice.frequency,
                volume: _setup.maxAgePercent,
              },
            })
          }
        ),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }